<template>
    <div class="modal fade" id="modal-cancellation">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">{{__("messages.cancellation_policy")}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>
                        <span>{{__("messages.description_cancellation_free")}} {{cancellation.cancellation.untilDateCancellation | date("D MMMM YYYY")}}, {{__("messages.description_cancellation_free_to")}} {{cancellation.dateCancellation | date("D MMMM YYYY") }}</span> {{__("messages.description_cancellation_penalty")}}.
                    </p>

                    <p>
                        <i>{{__("messages.dates_server_cancellation")}}</i>
                    </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btnPrimary btnPrimary--xs" data-dismiss="modal">{{__("messages.close")}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


    export default {
        props: [ 'cancellation' ],

        methods: {

        }
    }
</script>
